/**
 * @file   松林名琴坊
 * @create macaiqi 2025/07/23
 * @update 
 */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import cls from 'classnames'
import img1 from '../../assets/images/slmqg/bg1.png';
import img2 from '../../assets/images/slmqg/bg2.png';
import title from '../../assets/images/slmqg/title.png';

import './index.scss'

export default function SLMQF({ setToPage }) {
    const navigate = useNavigate()

    let floor = ["二层", "首层"];
    const [floorAt, setFloorAt] = useState(1); //1 首层  0二层
    return (
        <div className='common-page slmqgf-page '>
            <div
                className="back"
                onClick={() => {
                    setToPage();
                }}
            />
            <div className="floor">
                {floor.map((item, index) => {
                    return (
                        <div
                            className={cls("item", { active: index === floorAt })}
                            key={index}
                            onClick={() => {
                                setFloorAt(index);
                            }}
                        >
                            {item}
                            <i></i>
                        </div>
                    );
                })}
            </div>

            <div className="imgbox">
                <img src={title} alt="" srcset="" className='titleimg' />
                {floorAt === 1 && <>
                    <img src={img1} alt="" className='bg' style={{ height: "67.5rem" }} />
                    <div
                        className="go2"
                        onClick={() => {
                            setFloorAt(0)
                        }}
                    ></div>
                    <div className="start " onClick={() => {
                        navigate('/Game')
                    }} />


                </>}
                {floorAt === 0 && <>
                    <img src={img2} alt="" className='bg' style={{ height: "67.5rem" }} />
                    <div
                        className="go1"
                        onClick={() => {
                            setFloorAt(1);
                        }}
                    ></div>
                    <div className="start2 " onClick={() => {
                        navigate('/LLK')
                    }} />
                </>}


            </div>

        </div>
    )
}
